<template>
  <v-container>
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined iconName="mdi-pencil" @click="onEditInfo" :disabled="disabledByRole">기본 정보 수정</c-btn>
        <c-btn class="mx-1" color="grey" outlined iconName="delete" @click="onDeleteVehicle" :disabled="disabledByRole">삭제</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)" iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
      </v-col>
    </v-row>
    <div></div>
    <v-tabs v-model="tab" slider-color="blue" slider-size="3">
      <v-tab v-for="menu in menuItems" @click="selectedMenu = menu">
        <span class="font-weight-bold"> {{ menu.title }} </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="menu in menuItems">
        <component v-bind:is="menu.component"></component>
      </v-tab-item>
    </v-tabs-items>

    <vehicle-c-u-dialog
      :open.sync="editInfoDialog"
      :vehicleFormData="vehicleInfo"
      :availableDrivers="availableDrivers"
      @reqUpdateVehicle="reqUpdateVehicle"
    />
  </v-container>
</template>

<script>
  import VehicleInfo from './VehicleInfo';
  import RefuelingInfo from './RefuelingInfo';
  import MaintenanceInfo from './MaintenanceInfo';
  import VehicleCUDialog from "./VehicleCUDialog";
  import OperatingInfo from "@/views/Default/Vehicle/OperatingInfo";

  export default {
    components: {
      VehicleInfo, RefuelingInfo, MaintenanceInfo, OperatingInfo, VehicleCUDialog
    },
    data() {
      return {
        tab:null,
        selectedMenu: {},
        menuItems: [
          {title : '기본 정보', component : 'VehicleInfo'},
          {title: '운행 정보', component: 'OperatingInfo'},
          {title : '주유 정보', component : 'RefuelingInfo'},
          {title : '정비 정보', component : 'MaintenanceInfo'}
        ],
        editInfoDialog: false,
        vehicleInfo: {},

        availableDrivers: []
      }
    },
    mounted() {
      this.getVehicleInfo();
    },
    computed: {
      disabledByRole() {
        return this.$store.state.userInfo.role === 'RM';
      },
    },
    methods : {
      async getVehicleInfo() {
        const res = await this.$api.getVehicle(this.$route.params.vehicleId);
        this.vehicleInfo = res.data;
      },
      onEditInfo() {
        let data = this.vehicleInfo;
        this.vehicleInfo = {
          id: data.id,
          mainDriverId: data.mainDriver ? data.mainDriver.id : '',
          mainDriverName: data.mainDriver ? data.mainDriver.name : '',
          subDriver1Id: data.subDriver1 ? data.subDriver1.id : '',
          subDriver1Name: data.subDriver1 ? data.subDriver1.name : '',
          subDriver2Id: data.subDriver2 ? data.subDriver2.id : '',
          subDriver2Name: data.subDriver2 ? data.subDriver2.name : '',

          plateNo: data.plateNo,
          seatCnt: data.seatCnt.configValue,
          vehicleModelId: data.vehicleModel ? data.vehicleModel.id : null,
          hwUsage: data.hwUsage,
          inspectionDate: data.inspectionDate,
          registrationDate: data.registrationDate,
          expirationDate: data.expirationDate,
          confirm: 'f',
          vehicleOption: data.vehicleOption,
        };

        this.onShowVehicleDialog();
      },

      async reqUpdateVehicle(data) {
        try {
          const res = await this.$api.updateVehicle(data);

          if (data.confirm === 't') {
            this.editInfoDialog = false;
            location.reload();
          } else {
            // y일 경우 재귀 호출, n일 경우 confirm 다이얼로그만 끈다.
            this.onConfirmDialogOpen(res.data, data);
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateVehicle'});
        }

      },
      onDeleteVehicle() {
        this.$store.commit('alert', {
          open: true, msg: "기사가 배정된 차량은 해당 기사 예약건의 배차가 취소 됩니다.\n삭제를 원하는 경우 확인 버튼을 눌러주세요.",
          confirm: true, persistent: true,
          callBack: () => {
            this.reqDeleteVehicle();
          }
        });
      },
      async reqDeleteVehicle() {
        const res = await this.$api.deleteVehicle(this.$route.params.vehicleId);
        this.$store.commit('alert', {
          open: true, msg: "차량 정보가 삭제되었습니다.",
          persistent: true,
          callBack: () => {
            this.$router.push('/vehicle');
          }
        });
      },
      async reqAvailableDriverList() {
        try {
          const res = await this.$api.getAvailableDriverList();
          this.availableDrivers = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAvailableDriverList'});
        }
      },
      async onShowVehicleDialog() {
        try {
          await this.reqAvailableDriverList();
          this.editInfoDialog = true;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'onShowVehicleDialog'});
        }
      },
      onConfirmDialogOpen(msg, data) {
        msg = msg ? msg : '수정하시겠습니까?';

        this.$store.commit('alert',
          {
            open: true,
            persistent: true,
            msg: msg,
            confirm: true, callBack: () => {
              data.confirm = 't';
              this.reqUpdateVehicle(data);
            }
          });
      },
    }
  }

</script>

<style scoped>

</style>
